// extracted by mini-css-extract-plugin
module.exports = {"container":"Resources_container__3qSlQ","nav":"Resources_nav__1Q70e","content":"Resources_content__1E6J-"};